<div class="c-richClub">
  <slotcom-navigation-button
    type="close"
    rightPosition="5"
    (click)="closeModal()"></slotcom-navigation-button>

  <div class="c-richClub__container">
    <div class="c-richClub-icon"></div>
    @if (richClubData.data.modalName == 'code') {
      <div class="c-richClub__info">
        <div class="c-richClub__text">
          <span class="text title code-title">
            {{ 'home.modals.rich-club.code.subtitle' | translate | uppercase }}</span
          >
          <div class="login-code">
            @for (number of loginCode; track $index) {
              <div class="number-box">{{ number }}</div>
            }
          </div>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        (safeClick)="closeModal()"
        audioType="functionality">
        <span class="label">{{ 'common.accept' | translate | uppercase }}</span>
      </slotcom-button>

      <slotcom-animated-timer
        [endDate]="richClubData.data.validUntil"
        (expired)="closeModal()">
      </slotcom-animated-timer>
    }
  </div>
</div>
